module.exports = __webpack_public_path__ + "img/About_Freelancers_LIGHT-05.d7b0d6e.svg";